<template>
  <span>
    <span class="sum-wrap">
      滞留超3天：
      <span class="sum">{{ OrderStatistics?.totalStranded3DaysCount || 0 }}</span>
      单
    </span>
    <span class="sum-wrap">
      滞留超5天：
      <span class="sum">{{ OrderStatistics?.totalStranded5DaysCount || 0 }}</span>
      单
    </span>
    <span class="sum-wrap">
      近1周退件出库：
      <span class="sum">{{ OrderStatistics?.total1WeekOutCount || 0 }}</span>
      单
    </span>
    <span style="font-size: 12px; color: #aaaaaa">(滞留数据为全量数据统计，不受查询条件影响)</span>
  </span>
</template>

<script setup lang="ts">
import { ref, computed, useCurrentAppInstance, type AppEventListeners } from '@zto/zpage'

const props = withDefaults(
  defineProps<{
    contextData?: any
    listeners?: AppEventListeners
  }>(),
  {}
)

const app = useCurrentAppInstance()
const appApi = app.api

// 统计
const OrderStatistics: any = ref({})

const getData = async () => {
  OrderStatistics.value = await appApi.request({
    url: '/cabinet/admin/oms/AdminOmsShipmentQueryController/count',
    data: {}
  })
}

// 注册微件事件监听
app.useEventListeners(props.listeners, {
  sumSearchOn: async () => {
    getData()
  }
})
</script>

<style lang="scss" scoped>
.sum-wrap {
  margin-left: 12px;
}

.sum {
  color: red;
  font-weight: bolder;
  font-size: 18px;
}
</style>
